import { Library, CircleCheckBig, Users, Gift } from "lucide-react"

import StatTile from "./StatTile"

// D1 — the 4 real profile stat tiles ("Words delivered" dropped). Each deep-links
// into the surface that owns it. Values come straight from the presenter (real
// order/posting counts + reward points), so the strip never invents a figure.
const TILES = [
  { key: "activeProjects", label: "Active projects", href: "/projects", Icon: Library },
  { key: "completedProjects", label: "Completed projects", href: "/projects", Icon: CircleCheckBig },
  { key: "freelancersHired", label: "Freelancers hired", href: "/find-freelancers", Icon: Users },
  { key: "rewardPoints", label: "Reward points", href: "/rewards", Icon: Gift },
]

// P8-H7 "Muster" — the prototype ruled a FIVE-tile strip 5→3 at ≤1024 →2 at ≤640
// (design/spec/account/profile.html). D1 above left this app with FOUR tiles, and
// three-of-four orphans a tile, so this strip folds 4→2 instead of 5→3→2.
//
// WHERE it folds is a RULING, not an arithmetic consequence — the earlier note
// here said "~189px at 860", which was simply wrong. Measured tile widths with
// four across: 134.8px at 641, 133.5px at 860, 174.5px at 1024, 214.5px at 1280.
// Note that this strip sits ABOVE the page grid and spans the full content width
// on both sides of 861 (576px at 860, 577px at 861), so four tiles at 861 would
// measure 133.8px — the same as the 133.5px they already are at 860. The fold to
// two therefore tracks the page becoming two-column at 861, where the rest of
// this slice's density changes land; it is not this strip being physically
// narrowed. Folding everything below 1024 was the alternative and was rejected:
// it doubles the strip's height across the whole of 641–1023.
//
// So the ladder is expressed as DISJOINT bands rather than a cascade of overrides,
// and no two of them can ever contest `grid-template-columns`:
//   ≤640        base `grid-cols-2`                      (2 up)
//   641–860     `min-[641px]:max-[861px]`               (4 across)
//   861–1023    neither matches → falls back to base    (2 up, the starved band)
//   ≥1024       `min-[1024px]`                          (4 across)
// Tailwind v4 compiles `min-[N]` inclusive and `max-[N]` exclusive, so
// `min-[641px]:max-[861px]` is exactly 641 through 860.
export default function StatStrip({ stats }) {
  return (
    <div
      data-testid="stat-strip"
      className="grid grid-cols-2 gap-[14px] min-[641px]:max-[861px]:grid-cols-4 min-[1024px]:grid-cols-4"
    >
      {TILES.map(({ key, label, href, Icon }) => (
        <StatTile key={key} href={href} label={label} value={stats?.[key]} Icon={Icon} />
      ))}
    </div>
  )
}
